<template>
  <div class="company box-list">
    <tabs class="clean no-bg tabs--aligned">
      <template #header>
        <div class="header">
          <h2>Company</h2>
        </div>
        <nav class="top-actions">
          <primary-button
            v-if="isSuperAdmin"
            @click.prevent="showAddCompanyModal"
          >
            <icon name="add" />
            Add Company
          </primary-button>
          <div class="switch-view">
            <div
              class="view-btn"
              :class="{'active-view': activeView === 'list'}"
              @click="changeActiveView('list')"
            >
              <icon name="list-view" />
            </div>
            <div
              class="view-btn"
              :class="{'active-view': activeView === 'grid'}"
              @click="changeActiveView('grid')"
            >
              <icon name="grid-view" />
            </div>
          </div>
        </nav>
      </template>
    </tabs>
    <company-list
      ref="companyList"
      :view="activeView"
    />
  </div>
</template>
<script>
import Utils from "../../utils"
import { mapState } from "vuex"
import CompanyModal from "../common/modal/CompanyModal"
import CompanyList from "./CompanyList"

export default {
  name: "Company",
  components: {
    CompanyList
  },
  data () {
    return {
      activeView: "grid"
    }
  },
  computed: {
    isSuperAdmin () {
      return this.currentUser && this.currentUser.roles.super_admin
    },
    Utils () {
      return Utils
    },
    ...mapState(["currentUser"])
  },
  methods: {
    changeActiveView (view) {
      this.activeView = view
    },
    reloadCompanies () {
      this.$refs.companyList.fetchData()

      if (this.activeView === "grid") {
        this.$refs.companyList.changePage(1, 40, false)
      } else {
        this.$refs.companyList.changePage(1, 40, false)
      }
    },
    showAddCompanyModal () {
      this.$modal.show(CompanyModal, {
        action: this.reloadCompanies
      })
    },
    changeTab (tab) {
      this.activeTab = tab.title.toLowerCase()
    }
  }
}
</script>
